export default __webpack_public_path__ + "static/media/ellipse5.4272dbee.svg";